import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Inbound, no interrupción',
    feedback:
      'Contenido que educa y resuelve problemas reales con dispositivos: la marca acompaña al usuario antes del cierre comercial.',
  },
  {
    title: 'Omnicanalidad TNO',
    feedback:
      'Señal en vivo, programas de negocios y actualidad, Digest con SEO y redes coordinadas — un ecosistema, no piezas sueltas.',
  },
  {
    title: 'Retail + corporativo',
    feedback:
      'Llegamos al emprendedor, al comprador inteligente y al decisor de flotas tecnológicas que ya consume TNO Business y Franquicias.',
  },
];

const PorQueTNO = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} align="left" gutterBottom>
          ¿Por qué TNO Network
          <br />
          para Canguro?
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width="100%"
              height="100%"
              data-aos="fade-up"
              component={Card}
              display="flex"
              flexDirection="column"
              sx={{ borderTop: 4, borderColor: theme.palette.primary.main }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.feedback}</Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PorQueTNO;
